  <div id="main" [ngClass]="{'shifted': isOpen, 'backdrop': isOpen}" *ngIf="admin.isAdmin()" (click)="closeSidebar($event)">
    
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">

        <a class="menu" (click)="toggleNav($event)" >
          <i class="fi fi-rr-bars-staggered"></i>
        </a>
       
        <ul class="nav">
           {{ admin.user.name }}
          <li class="nav-item">
            <a class="nav-link " *ngIf="currentLang !== 'ge'" (click)="switchLanguage('ge')">
              <img class="flag" src="/assets/images/ge.png" alt="ქართული" />
            </a>
            <a class="nav-link " *ngIf="currentLang !== 'en'" (click)="switchLanguage('en')">
              <img class="flag" src="/assets/images/us.png" alt="English" />
            </a>
          </li>

           <li class="nav-item">
            <a class="nav-link text-color" href="https://app.ajaraheritage.ge/" target="_blank" ><i class="fi fi-rr-site-alt"></i></a>
          </li>

          <li class="nav-item ">
            <a class="nav-link text-color" (click)="logout()"><i class="fi fi-rr-sign-out-alt"></i></a>
          </li>
        </ul>
        

      </div>
    </nav> 

 
    <div #scrollContainer style="height: 100vh; overflow-y: auto;">
      <router-outlet></router-outlet>
    </div>

  </div>

  <div class="container-fluid" *ngIf="!admin.isAdmin()">
    <router-outlet></router-outlet>
  </div>

  <div class="sidebar" [ngClass]="{'open': isOpen}" *ngIf="admin.isAdmin()">
    <a routerLink="/">
      <img src="https://ajaraheritage.ge/icons/light.png" class="logo-sidebar ps-4"/>
    </a>


    <div class="list-group list-group-flush  ps-4 mt-2">

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"

        >
          <i class="fi fi-rr-house-chimney"></i>
          <span class="mx-1">მთავარი</span>
      </a>
     <a 
        class="list-group-item d-flex" 
        [routerLink]="['/menu']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('menu')"
        >
          <i class="fi fi-rr-drop-down"></i>
          <span class="mx-1">მენიუ</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/pages']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('pages')">
          <i class="fi fi-rr-browser"></i>
          <span class="mx-1">გვერდები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/posts']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('posts')">
           <i class="fi fi-rr-newspaper"></i>
          <span class="mx-1">სტატიები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/category']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('categories')">
           <i class="fi fi-rr-list"></i>
          <span class="mx-1">კატეგორიები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/slider']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('slider')">
           <i class="fi fi-rr-sliders-v"></i>
          <span class="mx-1">სლაიდი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/files']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-folder-open"></i>
          <span class="mx-1">ფაილები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/admins']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('admins')">
           <i class="fi fi-rr-admin-alt"></i>
          <span class="mx-1">ადმინები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/setting']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('settings')">
           <i class="fi fi-rr-settings"></i>
          <span class="mx-1">პარამეტრები</span>
      </a>

      


      
      

    </div>
  </div>






